import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import { SAVINGS_PRESET_IMAGES_QUERY_KEY } from 'app/hooks/useFetchSavingsPresetImages';

import { uploadSavingsPresetImage } from 'app/utils/savingsPresetUpload';

/**
 * Uploads a savings preset cover image (presign → PUT → verify) and refreshes the preset list on
 * success. Resolves to the verified file upload id.
 */
const useUploadSavingsPresetImage = (options?: UseMutationOptions<string, Error, File>) => {
  const queryClient = useQueryClient();

  return useMutation<string, Error, File>({
    mutationFn: (file: File) => uploadSavingsPresetImage(file),
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: [SAVINGS_PRESET_IMAGES_QUERY_KEY] });
      options?.onSuccess?.(data, variables, context);
    },
  });
};

export default useUploadSavingsPresetImage;
